const hasVideoControls = document.querySelectorAll( '.has-video-control' )
const icon = '<svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="26" cy="26" r="25" stroke="white" stroke-width="2"/><g class="video-control-pause"><rect x="28" y="16" width="4" height="21" rx="1" fill="white"/><rect x="20" y="16" width="4" height="21" rx="1" fill="white"/></g><g class="video-control-play"><path d="M38.4306 25.6263C39.1154 26.0075 39.1154 26.9925 38.4306 27.3737L20.4864 37.3638C19.8199 37.7349 19 37.253 19 36.4901L19 16.5099C19 15.747 19.8199 15.2651 20.4864 15.6362L38.4306 25.6263Z" fill="white"/></g></svg>';

function handleClick(e) {
  const video = e.currentTarget.closest( '.wp-block-cover' ).querySelector( 'video' )
  if ( !video ) {
    return
  }

  e.currentTarget.classList.toggle('video-is-paused')

  if ( video.paused ) {
    video.play()
  } else {
    video.pause()
  }
}

function createButton() {
  [...hasVideoControls].forEach( (hasVideoControl) => {
    const button = document.createElement('button')
    button.innerHTML = icon
    button.classList.add('video-control')
    button.addEventListener( 'click', handleClick )
    hasVideoControl.insertAdjacentElement('beforeend', button)
  } )
}

function init() {
  if (!hasVideoControls) {
    return
  }

  createButton()
}

export default {
  init,
}
